/* eslint-disable */
import {
  Button,
  Space,
  Dropdown,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import {
  MenuOutlined,
  HistoryOutlined,
  PlusOutlined,
  SearchOutlined,
  FormOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { CustomTable,CustomTableExtend } from "@/hocComponents";
import http from "@/utils/http";
import api from "@/utils/api";
import { Link } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
import InfoUpdateModal from "./component/infoUpdateModal";
import MoveModal from "./component/moveModal";
import EditModal from "./component/editModal";
import TrustModal from "./component/ChangeTrustModal";
import dayjs from "dayjs";
export default function UserList() {
  const pageRef = useRef(null);
  const addModalRef = useRef(null);
  const MoveModalRef = useRef(null);
  const InfoModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const TrustModalRef = useRef(null);
  const openModal = (modalRef) => modalRef.current?.setModelAdd?.();
  const addModal = () => openModal(addModalRef);
  const infoModal = () => openModal(InfoModalRef);

  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(true);
  const [stateOptions, setStateOptions] = useState([]);
  const [propTypeOptions, setPropTypeOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [countyOptions, setCountyOptions] = useState([]);
  const [supervisorOptions, setSupervisorOptions] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  supervisorOptions
  const initTableHead = {
    prop: null,
    groupCode: null,
    propName: null,
    street: null,
    city: null,
    state: null,
    zip: null,
    propType: null,
    unitStatus: null,
    longitude: null,
    latitude: null,
    propClass: null,
    status: null,
    county: null,
    supervisorName:null,
    units: null,
    accountId: null, 
    ownerName: null, 
  };
  const emptyHead = () => ({ ...initTableHead });
  const [tableHead, setTableHead] = useState(initTableHead);
  const tableHeadRef = useRef(initTableHead);
  const pageSizeRef = useRef(100);
  const reqIdRef = useRef(0);
  // 让本页表头的筛选框不弹出浏览器保存的地址
useEffect(() => commonFn.disableAutofill(pageRef.current), []);
  useEffect(() => {
    tableHeadRef.current = tableHead;
  }, [tableHead]);
  useEffect(() => {
    pageSizeRef.current = pagination.pageSize;
  }, [pagination.pageSize]);
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: pageSizeRef.current,
    });
  };
const ownerOptions = ownerList.map((item) => ({
  label: item.titleName,
  value: [item.firstName, item.middleName, item.lastName]
    .filter(Boolean)
    .join(" "),
}));
  //定义列
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        ((commonFn.btnAuthorityFlag("ViewDetail") ||
          commonFn.btnAuthorityFlag("EditProperty") ||
          commonFn.btnAuthorityFlag("PropertyMove") ||
          commonFn.btnAuthorityFlag("ChangeTrust")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("ViewDetail") && {
                  key: "view",
                  icon: <SearchOutlined style={{ color: "#1677FF" }} />,
                  label: <div>View Map</div>,
                },
                commonFn.btnAuthorityFlag("EditProperty") && {
                  key: "edit",
                  icon: <FormOutlined style={{ color: "#1677FF" }} />,
                  label: <div>Edit Property </div>,
                },
                commonFn.btnAuthorityFlag("PropertyMove") && {
                  key: "move",
                  icon: <HistoryOutlined style={{ color: "#1677FF" }} />,
                  label: <div>Property Move</div>,
                },
                commonFn.btnAuthorityFlag("ChangeTrust") && {
                  key: "change",
                  icon: <BankOutlined style={{ color: "#1677FF" }} />,
                  label: <div>Change Trust</div>,
                },
              ].filter(Boolean),
              onClick: (e) => handleDetailClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined className="col-blue" />
          </Dropdown>
        )) ||
        null,
    },
   {
  title: "Owner",
  dataIndex: "ownerName",
  width: 100,
  titleType: "Select",
  onChange: (e) => tableFilterFn(e, "ownerName", "Select"),
  selectOptions: ownerOptions,
  render: (_, record) => (
    <div>
      <div>{record.ownerName}</div>
      {record.ownerCode != null && record.ownerCode !== "" && (
        <div>({record.ownerCode})</div>
      )}
    </div>
  ),
},
    {
      title: "Entity",
      dataIndex: "trustName",
      width: 200,
      titleType: "Select",
      onChange: (e) => tableFilterFn(e, "trustName", "Select"),
      selectOptions: entityOptions,
      render: (_, record) => (
        <div>
          <div>{record.trustName}</div>
          {record.trust != null && record.trust !== "" && (
            <div>({record.trust})</div>
          )}
        </div>
      ),
    },

    {
      title: "Prop",
      dataIndex: "prop",
      width: 80,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "prop"),
    },
    {
      title: "Status",
      dataIndex: "propClass",
      width: 80,
      titleType: "Select",
      onChange: (e) => tableFilterFn(e, "propClass", "Select"),
      selectOptions: [
        { value: "P", label: "Active" },
        { value: "X", label: "Inactive" },
      ],
      render: (text) => {
        return text === null
          ? " "
          : text === "P"
            ? "Active"
            : text === "X"
              ? "Inactive"
              : " ";
      },
    },
    {
      title: "Address",
      dataIndex: "street",
      titleType: "Input",
      width: 180,
      onChange: (e) => tableFilterFn(e, "street"),
    },
    {
      title: "City",
      dataIndex: "city",
      titleType: "Select",
      width: 120,
      onChange: (e) => tableFilterFn(e, "city", "Select"),
      selectOptions: cityOptions,
    },
    {
      title: "State",
      dataIndex: "state",
      titleType: "Select",
      width: 60,
      onChange: (e) => tableFilterFn(e, "state", "Select"),
      selectOptions: stateOptions,
    },
    {
      title: "Zip",
      dataIndex: "zip",
      titleType: "Input",
      width: 80,
      onChange: (e) => tableFilterFn(e, "zip"),
    },
    {
      title: "County",
      dataIndex: "county",
      titleType: "Select",
      width: 120,
      onChange: (e) => tableFilterFn(e, "county", "Select"),
      selectOptions: countyOptions,
    },
    {
      title: "Prop Type",
      dataIndex: "propType",
      titleType: "Select",
      width: 100,
      onChange: (e) => tableFilterFn(e, "propType", "Select"),
      selectOptions: propTypeOptions,
    },
{
  title: "Units",
  dataIndex: "units",
  width: 60,
  titleType: "Input",
 onChange: (e) => {
  const raw = String(e?.target?.value ?? "");
  const digits = raw.replace(/\D/g, "");
  if (digits !== raw) {
    if (e?.target) e.target.value = digits;  // 非数字立刻清掉
    return;                                   // 不发请求
  }
  tableFilterFn(e, "units");
},
},
    {
      title: "Rent Rate",
      width: 100,
      dataIndex: "unitRentSUMStr",
    },
    {
      title: "Cost",
      dataIndex: "poValue",
      // titleType: "Input",
      width: 100,
      isBracketAmountFlag: true,
      // onChange: (e) => tableFilterFn(e, "poValue"),
    },
    {
      title: "PO.Date",
      dataIndex: "startDate",
      titleType: "DatePicker",
      width: 80,
      format: "MM/DD/YYYY",
      onChange: (e) => tableFilterFn(e, "startDate", "DatePicker"),
    },
 {
      title: "Management Co.",
      dataIndex: "companyName",
      titleType: "Select",
      width: 120,
      onChange: (e) => tableFilterFn(e, "companyId", "Select"),
      selectOptions: companyOptions,
    },
      {
  title: "Supervisor",
  dataIndex: "supervisorName",          
  titleType: "Select",
  width: 150,
  selectOptions: supervisorOptions,
  onChange: (e) => tableFilterFn(e, "accountId", "Select"),  
},
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  const normalizeQueryValue = (value) => {
    if (value === null || value === undefined) return "";
    return value;
  };

useEffect(() => {
  if (!refreshKey) return;         
  const head = emptyHead();
  setTableHead(head);
  tableHeadRef.current = head;
  getTableListFn(1, pageSizeRef.current, head);
}, [refreshKey]);

  // 初始化数据
  useEffect(() => {
    getTableListFn(1, pageSizeRef.current, initTableHead);
    Promise.allSettled([
      getStateData(),
      getCountyData(),
      getCityData(),
      getPropTypeData(),
      getCompanyData(),
      getEntityData(),
      getSupervisorData(),
      getOwnerIdList(), 
    ]);
  }, []);

  //列表
  const getTableListFn = async (
    current,
    pageSize,
    head = tableHeadRef.current,
  ) => {
    const reqId = ++reqIdRef.current;
       setTableLoading(true);
    try {
      const params = {
        page: current || 1,
        count: pageSize || pageSizeRef.current,
        ...head,
      };
      Object.keys(initTableHead).forEach((key) => {
        params[key] = normalizeQueryValue(params[key]);
      });
  if (params.startDate) {
      const d = dayjs(Number(params.startDate) || params.startDate);
      params.startDate = d.isValid() ? d.format("YYYY-MM-DD") : "";
    }
      const response = await http.get(api.showProperty, { params });

      if (reqId !== reqIdRef.current) return; // 过期响应直接丢弃
   
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }
      const list = (response.data.list || []).map((item, index) => ({
        ...item,
        "#": (params.page - 1) * params.count + index + 1,
        key: item.propId || `fallback-key-${params.page}-${index}`,
      }));
      setTableList(list);
      setPagination((prev) => ({
        ...prev,
        total: response.data.total || 0,
        current: params.page,
        pageSize: params.count,
      }));
    } catch (err) {
      if (reqId === reqIdRef.current) setError(err);
    } finally {
      if (reqId === reqIdRef.current) setTableLoading(false);
    }
  };

  const getStateData = async () => {
    try {
      // const response = await http.get(api.getStateDict);
      const response = await http.get(api.getStateDictByProperty);
      if (response.code === "1") {
        const options = response.data.map((item) => ({
          value: item.value,
          label: item.label,
        }));
        setStateOptions(options);
      }
    } catch (error) {
      console.error("Failed to fetch state data:", error);
    } finally {
    }
  };

  const getCityData = async () => {
    try {
      const response = await http.get(api.getCityDictByProperty);
      if (response?.code === "1") {
        setCityOptions(
          (response.data || []).map((item) => ({
            label: item?.label,
            value: item?.value,
          })),
        );
      }
    } catch (error) {
      console.error("Failed to fetch city data:", error);
    }
  };

  const getCountyData = async () => {
    try {
      const response = await http.get(api.getCountyDictByProperty);
      if (response?.code === "1") {
        setCountyOptions(
          (response.data || []).map((item) => ({
            label: item?.label,
            value: item?.value,
          })),
        );
      }
    } catch (error) {
      console.error("Failed to fetch county data:", error);
    }
  };

  const getPropTypeData = async () => {
    try {
      const response = await http.get(api.getPropTypeList);
      if (response.code === "1") {
        const options = response.data.map((item) => ({
          label: item?.name ,
          value: item?.code,
        }));
        setPropTypeOptions(options);
      }
    } catch (error) {
      console.error("Failed to fetch state data:", error);
    }
  };
  const getCompanyData = async () => {
    try {
      const response = await http.get(api.getCompanyDictList, {
        params: {
          listValue: "4",
        },
      });
      if (response.code === "1") {
        const options = response.data.map((item) => ({
          label: item.companyNameCode,
          value: item.companyId,
        }));
        setCompanyOptions(options);
      }
    } catch (error) {
      console.error("Failed to fetch state data:", error);
    }
  };

  const getEntityData = async () => {
    try {
      const response = await http.get(api.getTrustDictList);
      if (response.code === "1") {
        const options = response.data.map((item) => ({
          label: item.trustNameTitle,
          value: item.trustId,
          glChartNameId: item.glChartNameId,
        }));
        setEntityOptions(options);
      }
    } catch (error) {
      console.error("Failed to fetch state data:", error);
    }
  };
const getSupervisorData = async () => {
  try {
    const response = await http.get(api.getSupervisorSOList);
    if (response.code === "1") {
      const options = (response.data || []).map((item) => ({
        value: item.label?.accountId ?? item.value,   // 搜索传 accountId
        label: [item.label?.fullName, item.label?.groupCodes]
          .filter(Boolean)
          .join(" - "),
      }));
      setSupervisorOptions(options);
    }
  } catch (error) {
    console.error("Failed to fetch supervisor data:", error);
  }
};

const getOwnerIdList = async () => {
  try {
    const response = await http.get(api.getOwnerDictList);
    setOwnerList(response?.data || []);
  } catch (error) {
    console.error("Failed to fetch owner data:", error);
  }
};
  const handleDetailClick = (e, record) => {
    //  console.log("record", record);
    if (e.key === "view") {
      const params = record;
      const baseUrl = window.location.origin;
      const route = "/PropertyManagement/Property/Map";
      const paramString = new URLSearchParams(params).toString();
      const hash = `${route}${paramString ? `?${paramString}` : ""}`;
      const url = `${baseUrl}#${hash}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    if (e.key === "move") {
      MoveModalRef.current?.setModelAdd?.(record);
    }
    if (e.key === "edit") {
      EditModalRef.current?.setModelAdd?.(record);
    }
    if (e.key === "change") {
      TrustModalRef.current?.setModelAdd?.(record);
    }
  };


  // 处理分页变化
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(
      pagination.current,
      pagination.pageSize,
      tableHeadRef.current,
    );
  };

  useEffect(() => {
    setColumns(commonFn.handleColunmFn(initColumns));
  }, [
    stateOptions,
    propTypeOptions,
    companyOptions,
    entityOptions,
    cityOptions,
    countyOptions,
    supervisorOptions,
    ownerList, 
  ]);

  const refreshList = () =>
    getTableListFn(
      pagination.current,
      pagination.pageSize,
      tableHeadRef.current,
    );

  return (
  <div ref={pageRef}>
  <CustomTableExtend
  initColumns={initColumns}
  setColumns={setColumns}
  refreshKey={refreshKey}
  setRefreshKey={setRefreshKey}
  noShowList={["download", "UserUsage"]}
>
  <div>
    {(commonFn.btnAuthorityFlag("Map") && (
      <Space size="large">
        <Link target="_blank" to="/PropertyManagement/Property/MapAll">
          <Button className="btnNew">Map</Button>
        </Link>
        <Button className="btnNew" onClick={addModal}>
          <PlusOutlined />
          New
        </Button>
        <Button className="btnNew" onClick={infoModal}>
          Prop. Info Update
        </Button>
      </Space>
    )) ||
      null}
  </div>
 </CustomTableExtend>

      <CustomTable
       key={refreshKey}
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        tableScroll={{ x: "max-content", y: "calc(100vh - 280px)" }}
        rowKey="propId"
      />

      <AddModal ref={addModalRef} onSuccess={refreshList} />
      <InfoUpdateModal ref={InfoModalRef} onSuccess={refreshList} />
      <MoveModal ref={MoveModalRef} onSuccess={refreshList} />
      <EditModal ref={EditModalRef} onSuccess={refreshList} />
      <TrustModal ref={TrustModalRef} onSuccess={refreshList} />
    </div>
  );
}
